import React from 'react';
import { ActivityIndicator, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';

/** RN port of theme.css's .t-spinner — small accent-colored activity indicator. */
export default function Spinner({ style, size = 'small' }: { style?: StyleProp<ViewStyle>; size?: 'small' | 'large' }) {
  const t = useTheme();
  return <ActivityIndicator size={size} color={t.colors.accent} style={style} />;
}
